function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "path-1",
  points: "0.000727272727 0 40 0 40 39.9985455 0.000727272727 39.9985455"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "path-3",
  points: "0 40 40 40 40 0 0 0"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Admin",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Admin-Settings",
  transform: "translate(-20.000000, -89.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Side-Menu"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-13",
  transform: "translate(20.000000, 89.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Dashboard"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-15-Copy"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3"
}, /*#__PURE__*/React.createElement("g", {
  id: "Clip-2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.33345455,5.33309091 L1.33345455,2.00036364 C1.33345455,1.63127273 1.63163636,1.33309091 2.00072727,1.33309091 L38.0007273,1.33309091 C38.368,1.33309091 38.6661818,1.63127273 38.6661818,2.00036364 L38.6661818,5.33309091 L1.33345455,5.33309091 Z M38.6661818,38.0003636 C38.6661818,38.3676364 38.368,38.6658182 38.0007273,38.6658182 L2.00072727,38.6658182 C1.63163636,38.6658182 1.33345455,38.3676364 1.33345455,38.0003636 L1.33345455,6.66581818 L38.6661818,6.66581818 L38.6661818,38.0003636 Z M38.0007273,-0.00145454545 L2.00072727,-0.00145454545 C0.895272727,-0.00145454545 0.000727272727,0.896727273 0.000727272727,2.00036364 L0.000727272727,38.0003636 C0.000727272727,39.104 0.895272727,39.9985455 2.00072727,39.9985455 L38.0007273,39.9985455 C39.1043636,39.9985455 40.0007273,39.104 40.0007273,38.0003636 L40.0007273,2.00036364 C40.0007273,0.896727273 39.1043636,-0.00145454545 38.0007273,-0.00145454545 L38.0007273,-0.00145454545 Z",
  id: "Fill-1",
  fill: "#353755"
})), /*#__PURE__*/React.createElement("path", {
  d: "M2.66763636,3.33418182 C2.66763636,3.42145455 2.68581818,3.50509091 2.72036364,3.58509091 C2.74945455,3.66872727 2.79854545,3.74327273 2.86036364,3.80690909 C3.12218182,4.06872727 3.544,4.06872727 3.80763636,3.80690909 C4.06763636,3.54509091 4.06763636,3.12145455 3.80763636,2.85963636 C3.54036364,2.61236364 3.12763636,2.61236364 2.86036364,2.85963636 C2.73672727,2.98690909 2.66763636,3.156 2.66763636,3.33418182 Z",
  id: "Fill-4",
  fill: "#4860CF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.33363636,3.33418182 C5.33545455,3.37781818 5.33909091,3.42327273 5.34636364,3.46690909 C5.35363636,3.50690909 5.36818182,3.54872727 5.38636364,3.58509091 C5.40090909,3.62872727 5.42090909,3.66872727 5.44636364,3.70690909 C5.47181818,3.74145455 5.49727273,3.77418182 5.52636364,3.80690909 C5.79,4.06509091 6.21,4.06509091 6.47363636,3.80690909 L6.55363636,3.70690909 C6.57909091,3.66872727 6.59909091,3.62872727 6.61363636,3.58509091 C6.63181818,3.54872727 6.64636364,3.50690909 6.65363636,3.46690909 C6.66090909,3.42327273 6.66454545,3.37781818 6.66637196,3.33418182 C6.66818182,2.96509091 6.37181818,2.66509091 6.00454545,2.66327273 C5.82454545,2.66327273 5.65181818,2.73418182 5.52636364,2.85963636 C5.40454545,2.98690909 5.33545455,3.156 5.33363636,3.33418182 Z",
  id: "Fill-6",
  fill: "#4860CF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.19327273,3.80690909 C8.45509091,4.06872727 8.87872727,4.06872727 9.14054545,3.80690909 C9.40236364,3.54509091 9.40236364,3.12145455 9.14054545,2.85963636 C8.87327273,2.61236364 8.46054545,2.61236364 8.19327273,2.85963636 C7.93509091,3.12327273 7.93509091,3.54327273 8.19327273,3.80690909 Z",
  id: "Fill-8",
  fill: "#4860CF"
}), /*#__PURE__*/React.createElement("g", {
  id: "Clip-11"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4,16 L36,16 L36,9.33272727 L4,9.33272727 L4,16 Z M2.66727273,17.3345455 L37.3327273,17.3345455 L37.3327273,8 L2.66727273,8 L2.66727273,17.3345455 Z",
  id: "Fill-10",
  fill: "#353755"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4,36 L13.3327273,36 L13.3327273,19.9981818 L4,19.9981818 L4,36 Z M2.66727273,37.3345455 L14.6672727,37.3345455 L14.6672727,18.6654545 L2.66727273,18.6654545 L2.66727273,37.3345455 Z",
  id: "Fill-12",
  fill: "#353755"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.3327273,26.0018182 L36,26.0018182 L36,20 L17.3327273,20 L17.3327273,26.0018182 Z M16,27.3345455 L37.3327273,27.3345455 L37.3327273,18.6654545 L16,18.6654545 L16,27.3345455 Z",
  id: "Fill-13",
  fill: "#4860CF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.3327273,36.0018182 L36,36.0018182 L36,30 L17.3327273,30 L17.3327273,36.0018182 Z M16,37.3345455 L37.3327273,37.3345455 L37.3327273,28.6654545 L16,28.6654545 L16,37.3345455 Z",
  id: "Fill-14",
  fill: "#353755"
})))))));

function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.ef96b213.svg";
export { ForwardRef as ReactComponent };